import { AdjustViewport } from './AdjustViewport';
import { SetRootProperty } from './SetRootProperty';
import { RewritingAtag } from './RewritingAtag';
import { RegisterCustomEvent } from './RegisterCustomEvent';
import { SmoothScroll } from './SmoothScroll';
import { MobileNav } from './MobileNav';
import { MegaMenu } from './MegaMenu';
import { Tabswiper } from './Tabswiper';
import { Accordion } from './Accordion';
import { Scrollable } from './Scrollable';
import { Modal } from './Modal';

const COMMON = {
  init() {
    RegisterCustomEvent();
    AdjustViewport();
    SetRootProperty();
    RewritingAtag();
    SmoothScroll();
    MobileNav.init();
    MegaMenu.init();
    Tabswiper.init();
    Accordion.init();
    Scrollable.init();
    Modal.init();
  },
  resize() {
    AdjustViewport();
    SetRootProperty();
  },
};
export { COMMON };
